import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import "@/App.css";
import { PageHeader, Gallery } from "@/sections";

export default function DrumsPage() {
  const [content, setContent] = useState(null);
  const [items, setItems] = useState([]);
  useEffect(() => {
    Promise.all([
      api.get("/site-content").then((r) => setContent(r.data)).catch(() => {}),
      api.get("/instruments?type=drum").then((r) => setItems(r.data)).catch(() => {}),
    ]);
  }, []);
  return (
    <div className="App">
      <Nav artisanName={content?.artisan_name || "Sacred Instruments"} />
      <PageHeader
        eyebrow="Hand-Carved · Drums"
        title="Drums that carry a heartbeat"
        subtitle="From frame drums to ceremonial djembes, every drum is shaped slowly — listening for the voice the wood wants to release. Made in the Waitetuna workshop."
      />
      <Gallery items={items} emptyText="No drums yet — add them from the admin panel." />
      <Footer content={content || {}} />
    </div>
  );
}
